/**
 * 引取新規登録
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/backorders`

const orders_accepts_backorders = {
  namespaced: true,
  actions: {
    /**
    * 更新
    * @param commit
    * @param params
    * @return {Promise<unknown>}
    */
    update({ commit }, { id, params }) {
      return new Promise((resolve) => {
        const api_path = `${API_PATH}/${id}`
        Vue.$http.put(api_path, params).then(data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        })
      })
    },
  },
}
export default orders_accepts_backorders
